import { NgIf } from '@angular/common';
import { Component, inject, ViewEncapsulation } from '@angular/core';
import { StorageService } from '@services/storage.service';

@Component({
  selector: 'app-phone-order-user-banner',
  templateUrl: './phone-order-user-banner.component.html',
  styleUrls: ['./phone-order-user-banner.component.scss'],
  imports: [NgIf],
  encapsulation: ViewEncapsulation.None,
})
export class PhoneOrderUserBannerComponent {
  private storageService = inject(StorageService);

  public get isPhoneOrderUser(): boolean {
    return this.storageService.userId !== null;
  }
}
